export const types = {
  insurance: 'Convênio',
  particular: 'Particular',
  referral: 'Encaminhamento',
};

export function getName(value) {
  return types[value] || '-';
}
